var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    staticClass: "changeBind_mobile",
    attrs: {
      "mask-closable": false,
      "title": _vm.title,
      "width": "700"
    },
    on: {
      "on-cancel": _vm.close
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('div', {
    staticClass: "step_box"
  }, [_c('Steps', {
    staticClass: "steps",
    attrs: {
      "current": _vm.current
    }
  }, [_c('Step', {
    attrs: {
      "title": $t("bwaupg4", "安全验证")
    }
  }, [_vm._v("1")]), _c('Step', {
    attrs: {
      "title": _vm.accountType === 'MOBILE' ? $t("allzi75", "绑定手机号") : $t("gdxzzg4", "绑定邮箱")
    }
  }), _c('Step', {
    attrs: {
      "title": $t("gdpuew4", "绑定成功")
    }
  })], 1)], 1), _vm.visible ? _c('div', {
    staticStyle: {
      "margin": "15px"
    }
  }, [_c('Alert', {
    attrs: {
      "show-icon": "",
      "closable": "",
      "type": "warning"
    }
  }, [_vm._v(_vm._s(_vm.accountType === "MOBILE" ? $t("aa5fz317", "换绑手机号后，该手机号下的所有【iWork平台】账号将全部变更为最新手机号，请谨慎操作") : $t("yx2dv814", "换绑邮箱后，该邮箱下的所有【iWork平台】账号将全部变更为最新邮箱，请谨慎操作")))])], 1) : _vm._e(), _c('div', {
    staticClass: "bind-message"
  }, [_vm.current === 0 ? [_c('div', {
    staticClass: "send_box"
  }, [_c('div', [_vm.showRadio ? _c('Form', {
    attrs: {
      "label-position": "top",
      "label-colon": ""
    }
  }, [_c('FormItem', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "required": "",
      "label": $t("k2pbsb4", "验证方式")
    }
  }, [_c('RadioGroup', {
    on: {
      "on-change": _vm.accoutTypeChange
    },
    model: {
      value: _vm.redioType,
      callback: function ($$v) {
        _vm.redioType = $$v;
      },
      expression: "redioType"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "MOBILE"
    }
  }, [_c('span', [_vm._v($t("ewbd43", "手机号"))])]), _c('Radio', {
    attrs: {
      "label": "EMAIL"
    }
  }, [_c('span', [_vm._v($t("padf2", "邮箱"))])])], 1)], 1)], 1) : _vm._e(), _c('SendMessage', {
    ref: "sendMessage",
    staticClass: "send-message",
    attrs: {
      "accountType": _vm.redioType,
      "mode": "FORGET_PASSWORD",
      "exist": true
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  })], 1), _c('Poptip', {
    staticClass: "poptip",
    attrs: {
      "trigger": "hover"
    }
  }, [_c('div', {
    staticClass: "pop_title"
  }, [_vm._v($t("xcml07", "收不到验证码？"))]), _vm.checkMobile() === 'MOBILE' ? _c('div', {
    staticClass: "api",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l(_vm.mobileList, function (item) {
    return _c('div', {
      key: item,
      staticClass: "pop_content"
    }, [_vm._v(" " + _vm._s(item) + " ")]);
  }), 0) : _vm._e(), _vm.checkMobile() === 'EMAIL' ? _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l(_vm.emailList, function (item) {
    return _c('div', {
      key: item,
      staticClass: "pop_content"
    }, [_vm._v(" " + _vm._s(item) + " ")]);
  }), 0) : _vm._e()])], 1)] : _vm._e(), _vm.current === 1 ? [_c('div', {
    staticClass: "send_box"
  }, [_c('SendMessage', {
    ref: "sendMessage",
    staticClass: "send-message",
    attrs: {
      "accountType": _vm.accountType,
      "showText": !_vm.uuid,
      "mode": "REGISTER"
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }), _c('Poptip', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('div', {
    staticClass: "pop_title"
  }, [_vm._v($t("xcml07", "收不到验证码？"))]), _vm.checkMobile() === 'MOBILE' ? _c('div', {
    staticClass: "api",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l(_vm.mobileList, function (item) {
    return _c('div', {
      key: item,
      staticClass: "pop_content"
    }, [_vm._v(" " + _vm._s(item) + " ")]);
  }), 0) : _vm._e(), _vm.checkMobile() === 'EMAIL' ? _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l(_vm.emailList, function (item) {
    return _c('div', {
      key: item,
      staticClass: "pop_content"
    }, [_vm._v(" " + _vm._s(item) + " ")]);
  }), 0) : _vm._e()])], 1)] : _vm._e(), _vm.current === 2 ? [_c('div', {
    staticClass: "text-center pt-[40px] flex flex-col items-center"
  }, [_c('img', {
    staticStyle: {
      "width": "55px",
      "height": "55px"
    },
    attrs: {
      "src": require("../../assets/bindSucess.png"),
      "alt": ""
    }
  }), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "color": "#333333"
    }
  }, [_vm._v($t("d1spvi4", "操作成功"))]), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "#999999",
      "margin-top": "8px"
    }
  }, [_vm._v(" " + _vm._s(_vm.accountType === "MOBILE" ? $t("x6ufskm", "您的手机已经绑定成功，请使用新手机号进行操作") : $t("thdtpxl", "您的邮箱已经绑定成功，请使用新邮箱进行操作")) + " ")])])] : _vm._e()], 2), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_vm.current != 2 ? _c('Button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v($t("ev022", "取消"))]) : _vm._e(), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.current === 2 ? $t("g3yc2", "完成") : $t("btdio3", "下一步")))])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };